import { unsafeCSS } from 'lit'

export function base64ToDataUrl(base64: string) {
  return unsafeCSS(`data:image/svg+xml;base64,${base64}`)
}
